(function () {
  'use strict';

  var config = document.getElementById('tapanda-scrabble-a11y');
  if (!config || config.dataset.initialized === 'true') return;
  config.dataset.initialized = 'true';

  var inputLabel = config.dataset.inputLabel;
  var clearLabel = config.dataset.clearLabel;
  var removeLabel = config.dataset.removeLabel;
  if (!inputLabel || !clearLabel || !removeLabel) return;

  var wrapperSelector = '.tee-scrabble-wrapper';
  var formSelector = '#tee-artwork-form, #teeFormInputs';
  var scopeObservers = new Map();
  var structureObserver;
  var structureRoot;
  var discoveryObserver;
  var refreshPending = false;
  var labelNumber = 0;

  function setAttribute(node, name, value) {
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }

  function getLabelId(label) {
    var id = label.id;
    var selector = window.CSS && typeof window.CSS.escape === 'function' && !/[\0\uD800-\uDFFF]/.test(id)
      ? '#' + window.CSS.escape(id) : '[id]';
    var matches = id ? Array.from(document.querySelectorAll(selector)).filter(function (node) {
      return node.id === id;
    }) : [];
    if (matches.length === 1 && matches[0] === label) return id;
    do {
      labelNumber += 1;
      id = 'tapanda-scrabble-label-' + labelNumber;
    } while (document.getElementById(id));
    label.id = id;
    return id;
  }

  function labelWrapper(wrapper) {
    var input = wrapper.querySelector('input.tee__input[type="text"]');
    var field = wrapper.closest('.tee-field');
    var heading = field && field.querySelector('.tee-field__heading');
    var label = heading && Array.from(heading.children).find(function (node) {
      return !node.classList.contains('tee-asterisk') && node.textContent.trim();
    });

    if (input) {
      if (label) {
        setAttribute(input, 'aria-labelledby', getLabelId(label));
      } else {
        input.removeAttribute('aria-labelledby');
        setAttribute(input, 'aria-label', inputLabel);
      }
    }

    wrapper.querySelectorAll('.tee-scrabble__clear-btn').forEach(function (button) {
      setAttribute(button, 'aria-label', clearLabel);
    });
    wrapper.querySelectorAll('.tee-scrabble__words-item').forEach(function (item) {
      var word = item.querySelector('.tee-scrabble__word');
      var button = item.querySelector('.tee-scrabble__remove-btn');
      if (!button || !word) return;
      var name = word.textContent.replace(/\s+/g, ' ').trim();
      setAttribute(button, 'aria-label', removeLabel.replace('[name]', name).trim());
    });
  }

  function touchesStructure(records) {
    var selector = wrapperSelector + ', ' + formSelector;
    return records.some(function (record) {
      return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
        return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
      });
    });
  }

  function scheduleRefresh() {
    if (refreshPending) return;
    refreshPending = true;
    queueMicrotask(function () {
      refreshPending = false;
      refresh();
    });
  }

  function refresh() {
    var pageRoot = document.getElementById('MainContent') || document.querySelector('main');
    var searchRoot = pageRoot || document;
    var wrappers = Array.from(searchRoot.querySelectorAll(wrapperSelector));
    var nextScopes = new Set();

    wrappers.forEach(function (wrapper) {
      labelWrapper(wrapper);
      nextScopes.add(wrapper.closest(formSelector) || wrapper.closest('.tee-field') || wrapper);
    });

    scopeObservers.forEach(function (observer, scope) {
      if (!nextScopes.has(scope)) {
        observer.disconnect();
        scopeObservers.delete(scope);
      }
    });
    nextScopes.forEach(function (scope) {
      if (scopeObservers.has(scope)) return;
      var observer = new MutationObserver(scheduleRefresh);
      observer.observe(scope, { childList: true, subtree: true, characterData: true });
      scopeObservers.set(scope, observer);
    });

    if (wrappers.length) {
      if (discoveryObserver) {
        discoveryObserver.disconnect();
        discoveryObserver = null;
      }
      var nextRoot = pageRoot || wrappers[0].closest('[id^="MainProduct-"]') || wrappers[0].parentElement;
      if (nextRoot !== structureRoot) {
        if (structureObserver) structureObserver.disconnect();
        structureRoot = nextRoot;
        structureObserver = new MutationObserver(function (records) {
          if (touchesStructure(records)) scheduleRefresh();
        });
        structureObserver.observe(structureRoot, { childList: true, subtree: true });
      }
    } else if (!structureRoot || !structureRoot.isConnected) {
      if (structureObserver) structureObserver.disconnect();
      structureObserver = null;
      structureRoot = null;
      if (!discoveryObserver) {
        discoveryObserver = new MutationObserver(function (records) {
          var head = document.head;
          if (records.length && head && records.every(function (record) {
            return head.contains(record.target);
          })) return;
          scheduleRefresh();
        });
        discoveryObserver.observe(document.documentElement, { childList: true, subtree: true });
      }
    }
  }

  document.addEventListener('teeinblue:ready', scheduleRefresh);
  document.addEventListener('teeinblue:product-updated', scheduleRefresh);
  document.addEventListener('shopify:section:load', scheduleRefresh);
  refresh();
})();
